import { render } from "./BuilderDemoMenuSelection.vue?vue&type=template&id=c625a74a&scoped=true&ts=true&lang=pug"
import script from "./BuilderDemoMenuSelection.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderDemoMenuSelection.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderDemoMenuSelection.vue?vue&type=style&index=0&id=c625a74a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c625a74a"]])

export default __exports__